import CityPageTemplate from "@/pages/hawaii-city/CityPageTemplate";
import { hiloConfig } from "./data";

export default function HiloPage() {
  return <CityPageTemplate config={hiloConfig} />;
}